import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable, Subject } from "rxjs";
import Swal from "sweetalert2";
import { CommonWebService, DEVICE_CREDENTIALS, HttpResponse, NotificationDetail, UserHttpService } from "../public-api";

@Injectable({
    providedIn :'root'
})
export class NotificationService {
    public notification$: BehaviorSubject<NotificationDetail[]> = new BehaviorSubject<NotificationDetail[]>([]);

    constructor(
        private http: HttpClient,
        private userSessionService: UserHttpService,
        private commonService: CommonWebService,
    ) {}

    public notificationList(notification_status: boolean = true, search_keyword?: string) {
        let formData = new FormData();
        formData.append("user_id", this.userSessionService.getUserInfo.user_id);
        formData.append("usr_customer_track_id",this.userSessionService.getUserInfo.usr_customer_track_id);
        formData.append("token", this.userSessionService.userToken);
        formData.append("deviceType", DEVICE_CREDENTIALS.DEVICE_TYPE);
        formData.append("deviceToken", DEVICE_CREDENTIALS.DEVICE_TOKEN);
        formData.append("notification_status", notification_status ? '1' : '2');

        if(search_keyword) {
            formData.append('search_keyword', search_keyword ? search_keyword : '');
        }

        this.http.post<HttpResponse<NotificationDetail[]>>('notification/myNotification', formData).subscribe({
            next: ((res) => {
                if(res.status) {
                    this.notification$.next(res.data.length > 0 ? res.data : []);
                } else {
                    Swal.fire("Oops...", res.message, "error");
                }
            }),
            error: ((err) => {
                console.log(err);
                Swal.fire("Oops...", err, "error");
            })
        });
    }

    public notificationCounter(): Observable<HttpResponse<number>> {
        let formData = new FormData();
        formData.append("user_id", this.userSessionService.getUserInfo.user_id);
        formData.append("usr_customer_track_id",this.userSessionService.getUserInfo.usr_customer_track_id);
        formData.append("token", this.userSessionService.userToken);
        formData.append("deviceType", DEVICE_CREDENTIALS.DEVICE_TYPE);
        formData.append("deviceToken", DEVICE_CREDENTIALS.DEVICE_TOKEN);
        return this.http.post<HttpResponse<number>>('notification/notificationCounter', formData);
    }

    public deleteNotification(notificationId: string): Observable<HttpResponse<number>> {
        let formData = new FormData();
        formData.append("user_id", this.userSessionService.getUserInfo.user_id);
        formData.append("usr_customer_track_id",this.userSessionService.getUserInfo.usr_customer_track_id);
        formData.append("token", this.userSessionService.userToken);
        formData.append("deviceType", DEVICE_CREDENTIALS.DEVICE_TYPE);
        formData.append("deviceToken", DEVICE_CREDENTIALS.DEVICE_TOKEN);
        formData.append("notification_id", notificationId ? notificationId : "");
        return this.http.post<HttpResponse<number>>('notification/deleteNotification', formData);
    }

    public readNotifications(notificationId: string): Observable<HttpResponse<boolean>> {
        let formData = new FormData();
        formData.append("user_id", this.userSessionService.getUserInfo.user_id);
        formData.append("usr_customer_track_id",this.userSessionService.getUserInfo.usr_customer_track_id);
        formData.append("token", this.userSessionService.userToken);
        formData.append("deviceType", DEVICE_CREDENTIALS.DEVICE_TYPE);
        formData.append("deviceToken", DEVICE_CREDENTIALS.DEVICE_TOKEN);
        formData.append("notification_id", notificationId ? notificationId : "");
        return this.http.post<HttpResponse<boolean>>('notification/readNotification', formData);
    }
}